module.exports = __webpack_public_path__ + "static/media/FIV_POSITIVE.df62ca5a.svg";